import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@mui/material';
import { AppFormLayout, AppModal, ImplicitSubmit } from '@shared';

const propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onDeliver: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  order: PropTypes.object,

  modalProps: PropTypes.shape({
    title: PropTypes.string,
    primaryAction: PropTypes.object,
    secondaryActions: PropTypes.array,
  }),
}

const defaultProps = {
  modalProps: {},
  errors: {},
}

const OrderDeliveryModal = (props) => {
  const [recipientName, setRecipientName] = useState("");

  const deliver = () => {
    props.onDeliver(recipientName)
  }

  return(
    <AppModal
      large
      open={props.open}
      onClose={props.handleClose}
      title={ I18n.t("delivery_modal_title") }
      primaryAction={{
        content: I18n.t("actions.register"), onAction: deliver, loading: props.loading
      }}
      secondaryActions={[{
        content: I18n.t("actions.cancel"), onAction: props.handleClose, loading: props.loading
      }]}
    >
      <form onSubmit={ (event) => { event.preventDefault(); deliver(); } }>
        <AppFormLayout>
          <TextField
            fullWidth
            id="recipient_name"
            label={ I18n.t("activerecord.attributes.order.recipient_name") }
            placeholder={ "Jose" }
            value={recipientName}
            onChange={ (event) => setRecipientName(event.target.value) }
            error={ !!props.errors.recipient_name }
            helperText={ props.errors.recipient_name }
            InputLabelProps={{ shrink: true }}
          />
          <ImplicitSubmit />
        </AppFormLayout>
      </form>
    </AppModal>
  )
}

OrderDeliveryModal.propTypes = propTypes;
OrderDeliveryModal.defaultProps = defaultProps;

export default OrderDeliveryModal;